import { useEffect } from 'react';

export default function SEOHead({
  title,
  description,
  keywords,
  image,
  url,
  structuredData
}) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }

    const setMetaTag = (name, content, isProperty = false) => {
      if (!content) return;
      const attr = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attr}="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attr, name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    if (description) {
      setMetaTag('description', description);
      setMetaTag('og:description', description, true);
      setMetaTag('twitter:description', description);
    }
    if (keywords) {
      setMetaTag('keywords', keywords);
    }
    if (title) {
      setMetaTag('og:title', title, true);
      setMetaTag('twitter:title', title);
    }
    if (image) {
      setMetaTag('og:image', image, true);
      setMetaTag('twitter:image', image);
    }
    if (url) {
      setMetaTag('og:url', url, true);
    }

    let scriptEl = null;
    if (structuredData) {
      scriptEl = document.createElement('script');
      scriptEl.type = 'application/ld+json';
      scriptEl.text = JSON.stringify(structuredData);
      document.head.appendChild(scriptEl);
    }

    return () => {
      if (scriptEl && scriptEl.parentNode) {
        scriptEl.parentNode.removeChild(scriptEl);
      }
    };
  }, [title, description, keywords, image, url, structuredData]);

  return null;
}

